import React from 'react';
import style from './PageNotFound.scss';
import { APPEARANCES, Heading } from '../Heading';
import { Text } from '../Text';
import { Box } from 'wix-style-react';
import { NotFoundIcon } from '../svgs';

export const PageNotFound = () => {
  return (
    <div className={style.notFound} data-hook="page-not-found">
      <Box margin="200px 0" direction="vertical" align="center">
        <NotFoundIcon />
        <Box
          marginTop="28px"
          direction="vertical"
          align="center"
          padding="0 28px"
        >
          <Heading appearance={APPEARANCES.H3}>We Can’t Find that Page</Heading>
          <Text>
            It might have moved since last you checked. Try using our search to
            find what you need.
          </Text>
        </Box>
      </Box>
    </div>
  );
};
